export type ChatProvider = 'LEANCLOUD' | 'NETEASE';

export function resolveChatProvider(value: unknown): ChatProvider | null {
  if (typeof value !== 'string' || value.trim() === '') {
    return 'LEANCLOUD';
  }

  const normalized = value.trim().toUpperCase();
  return normalized === 'LEANCLOUD' || normalized === 'NETEASE' ? normalized : null;
}
